import { isFetchCollectionResultSuccessful, isFetchResultSuccessful } from '../../../entities/FetchResult'
import { fetchLoketEmployeeApiCall, fetchUnsyncedEmployeesApiCall } from '../../../entities/LoketUser/LoketUserService'
import trans from '../../../helpers/trans'
import { ToastType } from '../../../types'
import { TypedDispatch } from '../../store'
import { setToast } from '../../toasts/toastsReducer'
import {
    setFullLoketUser,
    setIsGetFullLoketUserSuccessful,
    setIsGetUnsyncedEmployeesSuccessful,
    setIsLoading,
    setUnsyncedEmployees,
} from './addUserFormReducer'

export const fetchUnsyncedEmployees = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setIsGetUnsyncedEmployeesSuccessful(false))

    try {
        const response = await fetchUnsyncedEmployeesApiCall()

        if (! isFetchCollectionResultSuccessful(response)) {
            dispatch(setToast({
                text: trans('errors.loketUnknownError'),
                type: ToastType.warning,
                shouldFadeOutAutomatically: false,
            }))

            return
        }

        dispatch(setUnsyncedEmployees(response.data))
        dispatch(setIsGetUnsyncedEmployeesSuccessful(true))
    } catch (error) {
        console.error('[fetchUnsyncedEmployees]', error)

        dispatch(setToast({
            text: trans('errors.loketUnknownError'),
            type: ToastType.warning,
            shouldFadeOutAutomatically: false,
        }))
    } finally {
        dispatch(setIsLoading(false))
    }
}

export const fetchFullLoketUser = (userId: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setIsGetFullLoketUserSuccessful(false))

    try {
        const response = await fetchLoketEmployeeApiCall(userId)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setToast({
                text: trans('errors.loketUnknownError'),
                type: ToastType.warning,
                shouldFadeOutAutomatically: false,
            }))

            return
        }

        dispatch(setFullLoketUser(response.data))
        dispatch(setIsGetFullLoketUserSuccessful(true))
    } catch (error) {
        console.error('[fetchFullLoketUser]', error)

        dispatch(setToast({
            text: trans('errors.loketUnknownError'),
            type: ToastType.warning,
            shouldFadeOutAutomatically: false,
        }))
        dispatch(setIsLoading(false))
    }
}
